import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import {
  Box,
  VStack,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  Image,
  extendTheme,
  TableContainer,
  SimpleGrid,
  Input,
  Text,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  FormLabel,
  useDisclosure,
  filter,
} from "@chakra-ui/react";
import { useRef } from "react";
import image1 from "../../assets/img/carousel-1.jpg";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-hot-toast";
import { numberToWords } from "../../utils/numberToWords";
import { useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
const GetMergeBill = () => {
  const location = useLocation();
  const { roomNo, registration } = location.state || {};
  console.log(registration, "registation");
  const [data, setData] = useState([]);
  const [registrationNo, setRegisTrationNo] = useState("");
  const [foodData, setFoodData] = useState([]);
  const [filterService, setFilterService] = useState([]);
  const [mergeData, setMergeData] = useState([]);
  const [services, setServices] = useState([]);
  const [rate, setRate] = useState([]);
  const [bill, setBill] = useState([]);
  const [count, setCount] = useState(0);
  const [filterRoomBill, setFilterRoomBill] = useState([]);
  const [roomBill, setRoomBill] = useState(0);
  const [room, setRoom] = useState([]);
  const [roomNos, setRoomNo] = useState("");
  const [roomRate, setRoomRate] = useState(0);
  const [foodBill, setFoodBill] = useState(0);
  const [roomCgst, setRoomSgst] = useState(0);
  const [foodCgst, setFoodSgst] = useState(0);
  const [service, setService] = useState([]);
  const [serviceGst, setServiceGst] = useState(0);
  const [serviceBills, setServiceBill] = useState(0);
  const [search, setSearch] = useState("");
  const [filterRoomBook, setFilterRoomBook] = useState([]);
  const [otherRate, setOtherRate] = useState([]);
  const [breakFast, setBreakFast] = useState(0);
  const [breakfastLunch, setBreakfastLunch] = useState(0);
  const [breakfastLunchDinner, setBreakfastLunchDinner] = useState(0);
  const [extraPersonRate, setExtraPerson] = useState(0);
  const [singleRoomRate, setSingleRoomRate] = useState(0);
  const [roomBook, setRoomBook] = useState([]);
  // const [roomBook,setRoomBook]=useState([]);
  const [printData, setPrintData] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    registration: "",
    checkIn: "",
    checkOut: "",
    billNo: "",
    phoneNo: "",
    total: "",
    roomNo: "",
    totalBilling: "",
    serviceName: "",
    price: 0,
    mergeBill: "",
    servicePrice: 0,
    roomBill: 0,
  });
  console.log(filterRoomBill, "filter");

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  // const handleSearchChange=(e)=>{
  //     setSearch(e.target.value)
  // }

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  const customerId = localStorage.getItem("customerId");
  console.log(customerId);
  const fetchRoomBook = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.tdrsoftware.in/api/getRoomBookData/${customerId}`,
      );
      setRoomBook(response.data.room);
    } catch (error) {}
  };
  const fetchOtherRate = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.tdrsoftware.in/api/getOtherRoomRate/${customerId}`,
      );
      setOtherRate(response.data.otherRoomRate);
    } catch (error) {
      toast.error("Failed to fetch other room rate data");
    }
  };

  const fetchData = async () => {
    const response = await axios.get(
      `https://api.hotel.tdrsoftware.in/api/getRoomBillData/${customerId}`,
    );
    setData(response.data);
  };
  const fetchMergeBill = async () => {
    const response = await axios.get(
      `https://api.hotel.tdrsoftware.in/api/getMergeBill/${customerId}`,
    );
    setBill(response.data);
  };
  const fetchMergeBillData = async () => {
    const response = await axios.get(
      `https://api.hotel.tdrsoftware.in/api/getMergedData/${customerId}`,
    );
    setService(response.data);
  };
  const fetchServiceData = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.tdrsoftware.in/api/getRoomService/${customerId}`,
      );
      setServices(response.data.roomService);
      console.log(response.data.roomService);
    } catch (error) {
      //toast.error(error.message)
    }
  };

  const fetchData2 = async () => {
    const response = await axios.get(
      `https://api.hotel.tdrsoftware.in/api/getFoodbilldata/${customerId}`,
    );
    setFoodData(response.data);
  };
  const unPaidFoodData = foodData.filter((item) => item.status === true);
  console.log(unPaidFoodData);
  const fetchData3 = async () => {
    try {
      const response = await axios.get(
        `https://api.hotel.tdrsoftware.in/api/getPrintData/${customerId}`,
      );
      const rooms = response.data;

      // Map over rooms and fetch images dynamically
      const updatedRooms = await Promise.all(
        rooms.map(async (room) => {
          if (room.image) {
            const imageResponse = await axios.get(
              `https://api.hotel.tdrsoftware.in/get-image/${room.image}`,
              {
                responseType: "blob", // Assuming image is returned as a blob
              },
            );

            // Create a URL for the image blob
            room.imageUrl = URL.createObjectURL(imageResponse.data);
          } else {
            room.imageUrl = null; // Handle cases where image is missing
          }
          return room;
        }),
      );

      console.log(updatedRooms, "updatedRooms");
      setPrintData(updatedRooms);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  let mergedData;
  let filteredRoomBills;
  let filteredFoodBills;
  // let totalRoomBill;
  //let totalBill;
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const resName = printData.map((item) => {
    return item.name;
  });
  console.log(resName, "resName");
  const restaurentName = resName.toString();
  console.log(typeof restaurentName, restaurentName, "restaurentName");
  let latestBillNo;
  for (let i = bill.length - 1; i >= 0; i--) {
    if (bill[i].billNo) {
      latestBillNo = bill[i].billNo;
      break;
    }
    continue;
  }
  console.log(latestBillNo, "latestBillNo");
  const formatTimeToAMPM = (time) => {
    const formattedTime = new Date(`6000-01-01T${time}`);
    return formattedTime.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  const generateBillNo = (latestBillNo, resName) => {
    const year = new Date().getFullYear(); // Get the current year

    // Extract initials from the restaurant name
    const getInitials = (name) => {
      const ignoreWords = ["and", "of", "the", "in", "&", "at"];

      return name
        .split(" ") // Split the name by spaces
        .filter((word) => !ignoreWords.includes(word.toLowerCase())) // Exclude ignored words
        .slice(0, 2) // Take only the first two valid words
        .map((word) => word[0]) // Take the first letter of each word and convert to uppercase
        .join(""); // Join the initials to form the prefix
    };

    const prefix = `${getInitials(resName)}-${year}-FB-`;
    // Create the prefix

    // If there is a latest bill number, extract the numeric part and increment it
    if (latestBillNo) {
      const parts = latestBillNo.split("-");
      const lastPart = parts[parts.length - 1]; // Get the last part of the split string
      const lastNumber = parseInt(lastPart, 10); // Get the last part of the billNo
      const newNumber = lastNumber + 1;
      return `${prefix}${newNumber}`; // Increment and return the new bill number
    }
    console.log(prefix, "prefix");

    // If no previous bill number, start from '1'
    return `${prefix}1`;
  };
  const newBillNo = generateBillNo(latestBillNo, restaurentName);
  function getFormattedCurrentDate() {
    const now = new Date(); // Get the current date and time

    // Format the date as "DD-MM-YYYY"
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0"); // getMonth() is 0-based, so +1
    const year = now.getFullYear();

    // Format the time as "HH:MM AM/PM"
    let hours = now.getHours();
    let minutes = String(now.getMinutes()).padStart(2, "0"); // Add leading zero to minutes if needed
    const period = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 24-hour time to 12-hour time, adjusting midnight to 12
    const date = `${day}-${month}-${year} `;
    const time = `${hours}:${minutes}${period.toLowerCase()}`;

    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}${period.toLowerCase()}`;

    return [formattedDate, date, time];
  }
  const newDate = getFormattedCurrentDate();

  let roomAdd = async () => {
    const filteredRoomBills = data.filter(
      (item) => item.registration === registrationNo,
    );
    let s = filteredRoomBills.map((item) => item.roomNo.trim());
    console.log(s, "s");
    let d = s.join(",").split(",");
    let formattedArr = d.map((item) => item.trim());

    console.log(d, "m");

    try {
      const responses = await Promise.all(
        formattedArr.map((item) =>
          axios.get(
            `https://api.hotel.tdrsoftware.in/api/getRoomDataByNo/${customerId}/${item}`,
          ),
        ),
      );

      // Step 3: Extract data from responses
      const roomData = responses.map((response) => response.data.room);
      console.log(roomData, "roomData");

      // Step 4: Set the room data in the state
      setRoom(roomData);
      const cateory = roomData[0].category;

      console.log(cateory, "cateory");
      const otherRoomRate = otherRate.filter(
        (item) => item.category === cateory,
      );
      setRate(otherRoomRate);
      setBreakFast(otherRoomRate[0]?.breakfastRate);
      setBreakfastLunch(otherRoomRate[0]?.breakfastwithLunchRate);
      //console.log(breakfastRate,'breakfastRate')
      setBreakfastLunchDinner(
        otherRoomRate[0]?.breakfastwithLunchAndDinnerRate,
      );
      setSingleRoomRate(otherRoomRate[0]?.singleRoomRate);
      setExtraPerson(otherRoomRate[0]?.extraPersonRate);
      console.log(otherRoomRate, "otherRoomRate");
    } catch (error) {
      console.error("Error fetching room data:", error);
    }
  };
  useEffect(() => {
    if (data.length > 0) {
      roomAdd();
    }
  }, [data]);

  console.log(otherRate, room, "room");
  const mergeBills = (e) => {
    const filteredRoomBook = roomBook.filter(
      (item) => item.registration === registrationNo,
    );
    setFilterRoomBook(filteredRoomBook);
    let no1 = 0;
    room?.forEach((item) => {
      if (item.roomNo) {
        no1 += 1;
      }
    });
    setCount(no1);

    let no = room?.map((item) => item.roomNo).join(",");

    let price = room?.reduce((a, b) => a + b.rate, 0);

    setRoomNo(no);
    setRoomRate(price);

    // console.log(filteredRoomBook,'filteredRoomBook')

    // Filter room bill data for the current customer
    const filteredRoomBills = data.filter(
      (item) => item.registration === registrationNo,
    );
    setData(filteredRoomBills);
    setFilterRoomBill(filteredRoomBills);

    const totalRoomBill = filteredRoomBills.reduce((acc, item) => {
      return parseFloat(acc) + parseFloat(item.total);
    }, 0);
    const rCgst = filteredRoomBills.reduce((acc, item) => {
      return parseFloat(acc) + parseFloat(item.cgst);
    }, 0);
    setRoomSgst(rCgst);

    setRoomBill(parseFloat(totalRoomBill));

    // Filter food bill data for the current customer
    const filteredFoodBills = unPaidFoodData.filter(
      (item) => item.registration === registrationNo,
    );
    setFoodData(filteredFoodBills);
    const totalFoodBill = filteredFoodBills.reduce((acc, item) => {
      return parseInt(acc) + parseInt(item.totalBilling);
    }, 0);
    const fCgst = filteredFoodBills.reduce((acc, item) => {
      return parseFloat(acc) + parseFloat(item.cgst);
    }, 0);
    setFoodSgst(fCgst);
    setFoodBill(parseFloat(totalFoodBill));
    const filteredServiceBills = service.filter(
      (item) => item.registration === registrationNo,
    );
    const Roomservices = filteredServiceBills[0]?.roomService;
    console.log(Roomservices, "filteredServiceBills");
    const gst = Roomservices
      ? Roomservices.filter((item) => item.gst === true) // Only process items where gst is true
          .map((item) =>
            services
              .filter(
                (service) => service.roomServiceName === item.roomServiceName,
              )
              .reduce(
                (acc, b) => acc + b.roomServicePrice * (b.cgst / 100 || 0),
                0,
              ),
          )
          .reduce((sum, val) => sum + val, 0)
      : 0; // Sum up all calculated values

    console.log(gst, "gst"); // Expected output: 2400

    setFilterService(Roomservices);
    setServiceGst(gst);
    const totalServiceBill = Roomservices
      ? Roomservices.reduce((acc, item) => {
          return parseInt(acc) + parseInt(item.roomServicePrice);
        }, 0)
      : 0;
    setServiceBill(totalServiceBill + gst * 2);
    setRoomBill(parseFloat(totalRoomBill) - (totalServiceBill + gst * 2));

    // You can merge or combine the filtered data as needed
    // For example, if you want to display them together, you can merge them into a single array
    const mergedData = [...filteredRoomBills, ...filteredFoodBills];
    // console.log(mergedData,filteredServiceBills,'service')
    setMergeData(mergedData);
    //  console.log(filteredRoomBills,'room')
    roomAdd();
  };
  //  console.log(room,'romsexy')
  console.log(serviceGst, "serviceBills");
  //console.log(roomNos,roomRate,count,'roomNos')

  // console.log(filterRoomBill,'room')
  // console.log(foodBill,'food')

  // console.log(mergeData,'merge');

  let serviceBill = parseFloat(formData.price);
  let totalBill;
  // console.log(mergeData,'meregData')
  // console.log(roomCgst,'roomcgst')
  let totalCgst = roomCgst + foodCgst + serviceGst;
  let totalSgst = roomCgst + foodCgst + serviceGst;
  if (serviceBill == 0) {
    totalBill = parseFloat(roomBill + foodBill + serviceBills);
  } else {
    totalBill = parseFloat(roomBill + foodBill + serviceBill + serviceBills);
  }

  let taxableAmount = totalBill - (roomCgst + foodCgst + serviceGst) * 2;
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormData({
      name: filterRoomBill[0].name,
      registration: filterRoomBill[0].registration,
      roomNo: filterRoomBill[0].roomNo,
      checkIn: filterRoomBill[0].checkIn,
      checkOut: filterRoomBill[0].checkOut,
      phoneNo: filterRoomBill[0].phoneNo,
      total: filterRoomBill[0].total,
      totalBilling: foodBill,
      billNo: newBillNo,
      serviceName: formData.serviceName,
      price: formData.price,
      mergeBill: totalBill,
      servicePrice: serviceBills,
      roomBill: roomBill,
    });
  };
  console.log(formData);
  const save = async () => {
    try {
      const response = await axios.post(
        "https://api.hotel.tdrsoftware.in/api/mergeBillRegister",
        {
          customerId: customerId,
          data: formData,
        },
      );
      console.log("Data Submitted: ", response.data);

      toast.success(response.data.message);
      setFormData({
        advance: "",
        total: "",
        due: "",
      });
    } catch (error) {
      toast.error(error);
    }
  };

  console.log(mergeData, "meregdata");
  const theme = extendTheme({
    colors: {
      darkBg: "#1a202c", // Dark background color
      darkText: "#cbd5e0", // Dark text color
    },
    components: {
      Table: {
        variants: {
          dark: {
            bg: "darkBg",
            color: "darkText",
            borderRadius: "md",
            borderWidth: "1px",
            borderColor: "black.700",
          },
        },
      },
      Td: {
        baseStyle: {
          borderColor: "gray.700",
          borderWidth: "1px",
        },
      },
      Th: {
        baseStyle: {
          borderColor: "gray.700",
          borderWidth: "1px",
        },
      },
    },
  });
  // const handleSubmit=(e)=>{
  //   e.preventDefault();
  //   setFormData({
  //     name:"Dibakar"
  //   })

  // }
  //console.log(formData,'formData')
  useEffect(() => {
    fetchData();
    fetchOtherRate();
    fetchMergeBill();
    fetchData2();
    fetchData3();
    fetchMergeBillData();
    fetchRoomBook();
    roomAdd();

    fetchServiceData();
    if (registration) {
      setRegisTrationNo(registration);
    }
  }, [registrationNo]);

  const checkInDate = new Date(data[0]?.checkIn);
  const checkOutDate = new Date(data[0]?.checkOut);

  const totalDays =
    Math.ceil((checkOutDate - checkInDate) / (1000 * 60 * 60 * 24)) ;

  console.log("totalDays:", totalDays);
  console.log("okkkkkkkkkkkkkkkkk", totalDays);
  const baseAmount = roomBill - (roomCgst + roomCgst);
  const ratePerDay = baseAmount / totalDays;

  return (
    <Box diplay="flex" flexDirection="column" p={10}>
      <Box display="flex" gap={10}>
        <Input
          width="50%"
          placeholder="Enter Registration No"
          value={registrationNo}
          onChange={(e) => setRegisTrationNo(e.target.value)}
        />
        <Button
          width="20%"
          onClick={mergeBills}
          bg="#FEA116"
          _hover={{ color: "white" }}
        >
          MergeBill
        </Button>
        <Button
          width="20%"
          onClick={handleSubmit}
          bg="#FEA116"
          _hover={{ color: "white" }}
        >
          Submit
        </Button>
        <Button
          width="20%"
          onClick={save}
          bg="#FEA116"
          _hover={{ color: "white" }}
        >
          Save
        </Button>
      </Box>
      <Box display="flex" gap={2}>
        <TableContainer width="full">
          <Table size="sm" variant="striped" colorScheme="yellow">
            <TableCaption>Room Data</TableCaption>
            <Thead>
              <Tr>
                <Th>Guest Name</Th>

                <Th>RoomNo</Th>
                <Th>Rate</Th>
                <Th>Sgst</Th>
                <Th>Cgst</Th>

                <Th>Total</Th>
              </Tr>
            </Thead>
            <Tbody>
              {mergeData.slice(0, 1)?.map((item, index) => (
                <Tr key={index}>
                  <Td>{item.name}</Td>

                  <Td>{item.roomNo}</Td>
                  <Td>{item.rate}</Td>
                  <Td>{item.sgst}</Td>
                  <Td>{item.cgst}</Td>

                  <Td>{item.total}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
        <TableContainer width="full">
          <Table size="sm" variant="striped" colorScheme="green">
            <TableCaption>Food Data</TableCaption>
            <Thead>
              <Tr>
                <Th>Food Item</Th>

                <Th>Room No</Th>
                <Th>Rate</Th>
                <Th>Sgst</Th>
                <Th>Cgst</Th>

                <Th>Total</Th>
              </Tr>
            </Thead>
            <Tbody>
              {mergeData.slice(1)?.map((order, index) => (
                <Tr key={index}>
                  <Td>{order.foodItem.map((item) => item.name).join(" , ")}</Td>

                  <Td>{order.roomNo}</Td>
                  <Td>{order.foodRate}</Td>
                  <Td>{order.sgst}</Td>
                  <Td>{order.cgst}</Td>

                  <Td>{order.totalBilling}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
        <TableContainer width="full">
          <Table size="sm" variant="striped" colorScheme="green">
            <TableCaption>Room Service</TableCaption>
            <Thead>
              <Tr>
                <Th>Service Name</Th>
                <Th>Price</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filterService?.map((order, index) => (
                <Tr key={index}>
                  <Td>{order.roomServiceName}</Td>

                  <Td>{order.roomServicePrice}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
      <Box
        display="flex"
        gap="10px"
        alignItems="center"
        justifyContent="space-evenly"
      >
        <Box
          width="40%"
          display="flex"
          alignItems="center"
          borderRadius="5px"
          p={4}
        >
          <FormLabel>Extra Charges </FormLabel>
          <Input
            required
            w="70%"
            bg="#FAFAFA "
            placeholder="Enter Service Name"
            name="serviceName"
            value={formData.serviceName}
            onChange={handleInputChange}
          />
        </Box>
        <Box
          width="40%"
          display="flex"
          alignItems="center"
          boxShadow="xl"
          borderRadius="5px"
          p={4}
        >
          <FormLabel>Price</FormLabel>
          <Input
            type="number"
            w="80%"
            bg="#FAFAFA "
            placeholder="Enter Price"
            name="price"
            value={formData.price}
            onChange={handleInputChange}
          />
        </Box>
      </Box>

      <Box
        width="800px"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        {mergeData.slice(0, 1) ? (
          <Card
            bg={image1}
            textAlign="center"
            ref={componentRef}
            border="1px solid black"
            ml={2}
            mr={2}
          >
            <Text color="purple" fontSize="18px" fontFamily="sans-serif" mt={5}>
              Final Bill
            </Text>
            <CardHeader
              display="flex"
              justifyContent="center"
              alignItems="center"
              gap={2}
              p={4}
              boxShadow="md"
            >
              <Box>
                {printData.map((item) => (
                  <Image
                    src={item.imageUrl}
                    w="200px"
                    h="120px"
                    p={2}
                    bg="#FAFAFA"
                    borderRadius="12px"
                  />
                ))}
              </Box>
              <Box
                color="purple"
                fontSize="18px"
                fontFamily="sans-serif"
                textAlign="left"
              >
                {printData.map((item) => (
                  <>
                    <Text fontSize="2xl" as="b">
                      {item.name}
                    </Text>
                    <Text fontSize="sm">{item.adress}</Text>
                    <Text fontSize="sm">{item.phoneNo}</Text>
                    <Text fontSize="sm">{item.website}</Text>

                    <Text fontSize="sm">Email id:{item.email}</Text>
                    <Text fontSize="sm">Gst No:{item.gstNo}</Text>
                  </>
                ))}
              </Box>
            </CardHeader>
            <SimpleGrid columns={1} spacing={1} p={2} textAlign="left">
              <CardBody border="1px solid black">
                {mergeData.slice(0, 1).map((item, index) => (
                  <Box
                    mb={4}
                    as="b"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    fontWeight="15px"
                    color="purple"
                  >
                    <Box>
                      <Text>Name:{item.name}</Text>
                      <Text>Address:{item.address}</Text>
                      <Text>CheckIn:{item.checkIn}</Text>
                      <Text>CheckIn Time:{item.checkInTime}</Text>
                      <Text>Date:{newDate[1]}</Text>
                      <Text>Booking By:{filterRoomBook[0]?.bookingBy}</Text>
                      {item.companyName !== "" ? (
                        <Text>Company Name:{item?.companyName}</Text>
                      ) : (
                        ""
                      )}
                    </Box>
                    <Box>
                      <Text>Phone:{item.phoneNo}</Text>
                      <Text>BillNo:{formData.billNo}</Text>
                      <Text>CheckOut:{item.checkOut}</Text>
                      {item.checkOutTime !== "Invalid Date" ? (
                        <Text>Checkout Time:{item.checkOutTime}</Text>
                      ) : (
                        ""
                      )}
                      {item.gstNo !== "" ? (
                        <Text>Company GstNo:{item?.gstNo}</Text>
                      ) : (
                        ""
                      )}
                      {/* <Text>Phone:{item.address}</Text> */}
                    </Box>
                  </Box>
                ))}
                <TableContainer width="full" mb={3}>
                  <Table size="sm" variant="simple">
                    {/* <TableCaption>Room Bill</TableCaption> */}
                    <Thead>
                      <Tr>
                        <Th border="1px solid black">Sl. NO</Th>
                        <Th border="1px solid black">Room No</Th>
                        <Th border="1px solid black">Rate Per Day</Th>
                        <Th border="1px solid black">Total Day</Th>
                        <Th border="1px solid black">Total Amount</Th>
                        <Th border="1px solid black">Cgst</Th>
                        <Th border="1px solid black">Sgst</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {room?.slice(0, 1).map((item, index) => (
                        <Tr key={index}>
                          {/* <Td border='1px solid black'>{index+1}</Td>
            <Td border='1px solid black'>Room Charges({roomNos})</Td>
            <Td border='1px solid black'>{filterRoomBook[0]?.singleRate===true? singleRoomRate :roomRate}</Td>
            <Td border='1px solid black'>{filterRoomBook[0]?.singleRate===true? singleRoomRate*0.06:roomRate*0.06}</Td>
            <Td border='1px solid black'>{filterRoomBook[0]?.singleRate===true? singleRoomRate*0.06:roomRate*0.06}</Td> */}
                          <Td border="1px solid black">{index + 1}</Td>
                          <Td border="1px solid black">{roomNos}</Td>
                          <Td border="1px solid black">
                            {filterRoomBook[0]?.singleRate
                              ? singleRoomRate
                              : Number(item.rate)}
                          </Td>
                          <Td border="1px solid black">{totalDays}</Td>
                          <Td border="1px solid black">
                            {filterRoomBook?.[0]?.singleRate
                              ? singleRoomRate * totalDays
                              : taxableAmount}
                          </Td>
                          <Td border="1px solid black">
                            {filterRoomBook[0]?.singleRate === true
                              ? singleRoomRate * 0.025
                              : roomCgst}
                          </Td>
                          <Td border="1px solid black">
                            {filterRoomBook[0]?.singleRate === true
                              ? singleRoomRate * 0.025
                              : roomCgst}
                          </Td>
                        </Tr>
                      ))}
                      {/* <Tr>
           
           <Td border='1px solid black'  >{2}</Td>
            <Td border='1px solid black'>{filterRoomBook[0]?.withBreakfast?"BreakFast Rate(CP)":filterRoomBook[0]?.withLunchDinner?"Breakfast-Lunch/Breakfast-Dinner(MAP)":filterRoomBook[0]?.roomOnly?"Room Only(EP)" :"Breakfast/Lunch/Dinner Rate(AP)"}</Td>
            <Td border='1px solid black'>{(filterRoomBook[0]?.withBreakfast? breakFast:filterRoomBook[0]?.withLunchDinner? breakfastLunch:filterRoomBook[0]?.roomOnly?0 :breakfastLunchDinner)*count}</Td>
            <Td border='1px solid black'>{(filterRoomBook[0]?.withBreakfast? breakFast*0.06:filterRoomBook[0]?.withLunchDinner? breakfastLunch*0.06 :filterRoomBook[0]?.roomOnly?0:breakfastLunchDinner*0.06)*count}</Td>
            <Td border='1px solid black'>{(filterRoomBook[0]?.withBreakfast? breakFast*0.06:filterRoomBook[0]?.withLunchDinner? breakfastLunch*0.06 :filterRoomBook[0]?.roomOnly?0:breakfastLunchDinner*0.06)*count}</Td>

           
        </Tr> */}
                      {/* <Tr>
           
           <Td border='1px solid black'  >{2}</Td>
            <Td border='1px solid black'>Extra Person Rate</Td>
            <Td border='1px solid black'>{filterRoomBook[0]?.extraPerson?extraPersonRate:0}</Td>
            <Td border='1px solid black'>{filterRoomBook[0]?.extraPerson?extraPersonRate*0.06:0}</Td>
            <Td border='1px solid black'>{filterRoomBook[0]?.extraPerson?extraPersonRate*0.06:0}</Td>

           
        </Tr> */}
                      {/* <Tr>
           
           <Td border='1px solid black'>{4}</Td>
            <Td border='1px solid black'>Service  Rate</Td>
            <Td border='1px solid black'>{serviceBills}</Td>
            <Td border='1px solid black'>{0}</Td>
            <Td border='1px solid black'>{0}</Td>

           
        </Tr> */}
                    </Tbody>
                  </Table>
                </TableContainer>
                {mergeData.slice(1).length > 0 ? (
                  <TableContainer width="full">
                    <Table size="sm" variant="unstyled">
                      {/* <TableCaption>Food Bill</TableCaption> */}
                      <Thead>
                        <Tr>
                          <Th border="1px solid black">Food Name</Th>
                          <Th border="1px solid black">RoomNo</Th>
                          <Th border="1px solid black">Cgst</Th>
                          <Th border="1px solid black">Sgst</Th>
                          <Th border="1px solid black">Rate</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {mergeData?.slice(1)?.map((order, index) => (
                          <Tr key={index}>
                            <Td border="1px solid black">
                              <Table variant="simple" size="sm">
                                <Thead>
                                  <Tr>
                                    <Th>Name</Th>
                                    <Th>Quantity</Th>
                                    <Th>Price</Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {order?.foodItem.map((item) => (
                                    <Tr>
                                      <Td>{item.name}</Td>
                                      <Td>{item.quantity}</Td>
                                      <Td>{item.price}</Td>
                                    </Tr>
                                  ))}
                                </Tbody>
                              </Table>
                            </Td>
                            <Td border="1px solid black">{order?.roomNo}</Td>
                            <Td border="1px solid black">{order?.cgst}</Td>
                            <Td border="1px solid black">{order?.sgst}</Td>
                            <Td border="1px solid black">
                              {order?.totalBilling - order?.cgst * 2}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                ) : (
                  ""
                )}

                {filterService.length > 0 ? (
                  <TableContainer width="full" mb={3} mt={3}>
                    <Table size="sm" variant="simple">
                      {/* <TableCaption>Room Bill</TableCaption> */}
                      <Thead>
                        <Tr>
                          <Th border="1px solid black">Sl NO</Th>
                          <Th border="1px solid black">Room Service</Th>
                          <Th border="1px solid black">Price</Th>
                          <Th border="1px solid black">CGST</Th>
                          <Th border="1px solid black">SGST</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {filterService?.map((item, index) => {
                          const gstValue = item.gst
                            ? services
                                .filter(
                                  (service) =>
                                    service.roomServiceName ===
                                    item.roomServiceName,
                                )
                                .reduce(
                                  (acc, service) =>
                                    acc +
                                    (service.roomServicePrice / 100) *
                                      (service.cgst || 0),
                                  0,
                                )
                            : 0;

                          return (
                            <Tr key={index}>
                              <Td border="1px solid black">{index + 1}</Td>
                              <Td border="1px solid black">
                                {item.roomServiceName}
                              </Td>
                              <Td border="1px solid black">
                                {item.roomServicePrice}
                              </Td>

                              <Td border="1px solid black">{gstValue}</Td>
                              <Td border="1px solid black">{gstValue}</Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </TableContainer>
                ) : (
                  ""
                )}
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="start"
                  width="22%"
                  p={2}
                  alignItems="start"
                  color="black"
                  border="1px solid black"
                  fontSize="sm"
                  mt={5}
                >
                  <Text>CGST -- 2.5%</Text>
                  <Text>SGST -- 2.5%</Text>
                  <Text>CGST -- 2.5%</Text>
                  <Text>SGST -- 2.5%</Text>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  color="purple"
                  fontSize="sm"
                >
                  <Box>
                    <Text>Bank Details</Text>
                    {printData.map((item) => (
                      <>
                        <Text>A/C NO - {item.acNo}</Text>
                        <Text>IFSC CODE - {item.ifsc}</Text>
                        <Text>BRANCH - {item.branch}</Text>
                        {/* <Text>CONTACT NO - {item.phoneNo}</Text> */}
                      </>
                    ))}
                  </Box>
                  <Box display="flex" flexDirection="row" p={2}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      border="1px solid black"
                    >
                      <Text borderBottom="1px solid black" bg="gray.200" p={1}>
                        Summary
                      </Text>
                      <Text p={0.5}>Gross Amount</Text>
                      <Text p={0.5}>Taxable Amount</Text>
                      <Text p={0.5}>{formData.serviceName}</Text>
                      <Text p={0.5}>CGST Amount</Text>
                      <Text p={0.5}>SGST Amount</Text>
                      <Text p={0.5}>Grand Total</Text>
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      borderTop="1px solid black"
                      borderRight="1px solid black"
                      borderBottom="1px solid black"
                      borderLeft="0"
                    >
                      <Text p={1} borderBottom="1px solid black" bg="gray.200">
                        Amount
                      </Text>
                      <Text p={0.5}>{totalBill}</Text>
                      <Text p={0.5}>
                        {taxableAmount +
                          filterService
                            ?.filter((service) => service.gst)
                            .reduce((a, b) => {
                              return a + b.roomServicePrice;
                            }, 0)}
                      </Text>
                      {formData.serviceName ? (
                        <Text p={0.5}>{formData.price}</Text>
                      ) : (
                        ""
                      )}
                      <Text p={0.5}>{totalCgst}</Text>
                      <Text p={0.5}>{totalSgst}</Text>
                      <Text p={0.5} borderTop="1px solid black">
                        {totalBill}
                      </Text>
                    </Box>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-around"
                  gap={4}
                  alignItems="center"
                  p={0.5}
                  mt={1}
                >
                  <Text as="b" fontSize="sm">
                    Extra Charges - {formData.price}
                  </Text>
                  <Text as="b" fontSize="sm">
                    Total Amount(INR - In Words) -
                    {numberToWords(totalBill + serviceBills)}
                  </Text>
                </Box>
              </CardBody>
            </SimpleGrid>
            <CardFooter
              display="flex"
              justifyContent="space-between"
              p={25}
              textAlign="left"
            >
              <Box color="purple" fontSize="15px" fontFamily="sans-serif">
                {printData.map((item) => (
                  <>
                    {/* <Text>A/C NO - {item.acNo}</Text>
            <Text>IFSC CODE - {item.ifsc}</Text>
            <Text>BRANCH - {item.branch}</Text> */}
                    {/* <Text>CONTACT NO - {item.phoneNo}</Text> */}

                    <Text>Front Office Signature</Text>
                    <Text>Date-</Text>
                  </>
                ))}
              </Box>
              <Box
                mr={20}
                color="purple"
                fontSize="15px"
                fontFamily="sans-serif"
              >
                <Text>Guest Signature</Text>
                <Text>Date-</Text>
              </Box>
            </CardFooter>
          </Card>
        ) : (
          ""
        )}
        {mergeData ? (
          <Button
            type="submit"
            variant="solid"
            color="#0F172B"
            bg="#FEA116"
            _hover={{ color: "white" }}
            mt={5}
            onClick={handlePrint}
          >
            Print
          </Button>
        ) : (
          ""
        )}
      </Box>
    </Box>
  );
};
export default GetMergeBill;
